import React from 'react'
import { Link } from 'react-router-dom'
import s from '../css/error404.module.css'
import perrito404 from '../image/perrito404.png'


const Error404 = () => {
  return (
    <div className={s.conten} >
        <h2 className={s.h2}>Sorry</h2>
        <h3 className={s.p} >It seems that this page does not exist</h3>
        <p className={s.p} >Visit the main page</p>
        
        <Link to={"/home/"}>
            <h2>Home</h2>
        </Link>
        <img src={perrito404} />
        
    </div>
  )
}

export default Error404